var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9718 9.47295C11.8003 8.31842 12.19 6.90948 12.0716 5.49647C11.9532 4.08346 11.3345 2.75791 10.3252 1.75534C9.31599 0.752776 7.98167 0.138132 6.55936 0.0206264C5.13705 -0.0968794 3.71886 0.290364 2.5568 1.11355L10.9718 9.47295Z",
    fill: "#DA1E28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1335 2.52754C0.304984 3.68207 -0.0847045 5.09101 0.0336764 6.50402C0.152057 7.91703 0.770841 9.24258 1.78007 10.2451C2.78931 11.2477 4.12363 11.8624 5.54594 11.9799C6.96825 12.0974 8.38644 11.7101 9.5485 10.8869L1.1335 2.52754Z",
    fill: "#DA1E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalStatus);
export default __webpack_public_path__ + "static/media/critical_status.1b916525af1775c0ad5af52ee37df9c0.svg";
export { ForwardRef as ReactComponent };